import { FilesWorkflowNode } from 'app/core/enums';
import { StepBarNode } from '../step-bar';

export const FILES_WORKFLOW_NODE_CONFIGS: StepBarNode[] = [
  {
    key: FilesWorkflowNode.UploadScans,
    title: 'general.uploadScans',
  },
  // {
  //     key: FilesWorkflowNode.UploadPhotos,
  //     title: 'general.uploadPhotos',
  // },
];
